import { useSelector } from "react-redux";
import { Tag, Tooltip } from "antd";
import { HollowDotsSpinner } from "react-epic-spinners";
import dayjsTZ from "../../../../utils/dayjs";
import useAquamanDuty from "../../../../hooks/useAquamanDuty";
import "./AquamanWidget.scss";

// Employee dashboard card: who is on water duty this week, and the next few
// turns so people can see their own coming up.
const AquamanWidget = () => {
  const { isDarkMode } = useSelector((state) => state.usersList);
  const { loading, current, upcoming, roster, isMyDuty } = useAquamanDuty({
    upcoming: 5,
  });

  if (loading) {
    return (
      <div className="aquamanWidget loading">
        <HollowDotsSpinner color="#1da193" size={24} />
      </div>
    );
  }

  if (!current?.employeeName) {
    return (
      <div className={`aquamanWidget ${isDarkMode ? "dark" : ""}`}>
        <div className="aquamanWidgetEmpty">
          Nuk ka Aquaman të caktuar për këtë javë
          {roster?.teamLabel ? ` (${roster.teamLabel})` : ""}.
        </div>
      </div>
    );
  }

  return (
    <div className={`aquamanWidget ${isDarkMode ? "dark" : ""}`}>
      <div className={`aquamanCurrent ${isMyDuty ? "mine" : ""}`}>
        <span className="aquamanWidgetLabel">
          {isMyDuty ? "Këtë javë jeni ju" : "Aquaman i javës"}
        </span>
        <span className="aquamanWidgetName">{current.employeeName}</span>
        <span className="aquamanWidgetRange">
          {dayjsTZ(current.weekStart).format("DD/MM")} -{" "}
          {dayjsTZ(current.weekEnd).format("DD/MM/YYYY")}
          {current.status === "covered" ? (
            <Tooltip title="Zëvendëson një koleg me leje; java e tij vjen më vonë.">
              <Tag color="orange">zëvendësim</Tag>
            </Tooltip>
          ) : null}
        </span>
      </div>

      {upcoming.length > 0 ? (
        <ul className="aquamanUpcoming">
          {upcoming.slice(0, 4).map((week) => (
            <li key={week.weekStart}>
              <span className="date">
                {dayjsTZ(week.weekStart).format("DD/MM")}
              </span>
              <span className="name">{week.employeeName}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default AquamanWidget;
